export type ProcessingStatus = "queued" | "processing" | "ready" | "failed"

export const PROCESSING_LABELS: Record<ProcessingStatus, string> = {
  queued: "Queued",
  processing: "Processing",
  ready: "Ready",
  failed: "Failed",
}

export const PROCESSING_TONES: Record<ProcessingStatus, "neutral" | "accent" | "signal" | "muted"> = {
  queued: "muted",
  processing: "accent",
  ready: "neutral",
  failed: "signal",
}

export type SheetRow = {
  id: number
  label: string
  page_number: number
  rotation: number
  status: ProcessingStatus
  error_message: string | null
  editor_url: string
}

export type PlanSetRow = {
  id: number
  title: string
  status: ProcessingStatus
  page_count: number | null
  selected_pages: number[]
  rendered_pages: number[]
  error_message: string | null
  download_url: string
  render_pages_url: string
  picker_url: string
  created_by: string
  created_at: string
  sheets: SheetRow[]
}

type RenderProgressSource = Pick<PlanSetRow, "page_count" | "selected_pages" | "rendered_pages">

// Initial processing renders the upload's selection (all pages when the
// selection is empty or entirely out of range — mirrors PlanSet#pages_to_render).
export function renderTarget(planSet: RenderProgressSource): number {
  const count = planSet.page_count
  if (!count) return 0
  const picked = planSet.selected_pages.filter((page) => page >= 1 && page <= count)
  return picked.length > 0 ? picked.length : count
}

export function renderedOfTarget(planSet: RenderProgressSource): number {
  const count = planSet.page_count
  if (!count) return 0
  const picked = new Set(planSet.selected_pages.filter((page) => page >= 1 && page <= count))
  if (picked.size === 0) return planSet.rendered_pages.length
  return planSet.rendered_pages.filter((page) => picked.has(page)).length
}

export function anyProcessing(plans: PlanSetRow[]): boolean {
  return plans.some(
    (plan) =>
      plan.status === "queued" ||
      plan.status === "processing" ||
      plan.sheets.some((sheet) => sheet.status === "queued" || sheet.status === "processing"),
  )
}
